import { NgModule } from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { CommonModule } from '@angular/common';

import {UiMessageComponent} from './message.component';

@NgModule({
  declarations: [UiMessageComponent],
  imports: [FormsModule, ReactiveFormsModule, CommonModule],
  exports: [UiMessageComponent]
})
export class UiMessageModule { }
